/**
 * Services Catalog - Single Source of Truth
 * 
 * This file defines all orderable services with their routing configuration.
 * Use this catalog everywhere to ensure consistency across the site.
 */

export const SERVICES_CATALOG = [
  {
    key: "photo_restoration",
    slug: "photo-restoration",
    title: "Photo Restoration",
    shortTitle: "Photo Restoration",
    orderPath: "/order/photo-restoration",
    servicePath: "/services/photo-restoration",
    description: "Restore damaged, faded, or aged photographs with precision AI and hand-crafted refinement.",
    shortDescription: "Restore cherished photos to their original glory",
    ctaLabel: "Order Photo Restoration",
    icon: "ImagePlus",
    priceRange: "From $25",
    features: [
      "Vintage photo repair",
      "Noise & artifact removal",
      "Color fading correction",
      "Gallery-scale print prep"
    ]
  },
  {
    key: "lora_training",
    slug: "lora-training",
    title: "LoRA Training",
    shortTitle: "Digital Persona",
    orderPath: "/order/lora-training",
    servicePath: "/services/digital-persona-development",
    description: "Create your own AI-powered digital identity with custom SDXL LoRA model training.",
    shortDescription: "Train your own AI persona model",
    ctaLabel: "Order LoRA Training",
    icon: "Cpu",
    priceRange: "From $125",
    features: [
      "Precision dataset curation",
      "Private SDXL LoRA training",
      "Trigger word calibration",
      "Commercial-ready delivery"
    ]
  },
  {
    key: "photo_scanning",
    slug: "photo-scanning",
    title: "Photo Scanning",
    shortTitle: "Photo Scanning",
    orderPath: "/order/photo-scanning",
    servicePath: "/order/photo-scanning",
    description: "Professional digitization of physical photographs, slides, and negatives with archival quality.",
    shortDescription: "Digitize your physical photo collection",
    ctaLabel: "Order Photo Scanning",
    icon: "ScanLine",
    priceRange: "From $15",
    features: [
      "High-resolution scanning",
      "Color correction",
      "Dust & scratch removal",
      "Organized digital delivery"
    ]
  }
];

/**
 * Get a service by its key (e.g., "photo_restoration")
 */
export function getServiceByKey(key) {
  return SERVICES_CATALOG.find(s => s.key === key);
}

/**
 * Get a service by its slug (e.g., "photo-restoration")
 */
export function getServiceBySlug(slug) {
  return SERVICES_CATALOG.find(s => s.slug === slug);
}

/**
 * Get the order path for a service key
 */
export function getOrderPath(key) {
  const service = getServiceByKey(key);
  return service ? service.orderPath : "/orders/new";
}

/**
 * Get all services as an array
 */
export function getAllServices() {
  return SERVICES_CATALOG;
}

export default SERVICES_CATALOG;
